import React from 'react';

import Container from 'components/ui/Container';

import * as Styled from './styles';

const Footer = () => (
  <Styled.Footer>
    <Container>
      <Styled.Links>
        <Styled.Link
          href="https://github.com/raylon-silberman"
          rel="noreferrer noopener"
          target="_blank"
        >
          Github
        </Styled.Link>
        <Styled.Link
          href="https://www.linkedin.com/in/ray-s-aba81972/"
          rel="noreferrer noopener"
          target="_blank"
        >
          LinkedIn
        </Styled.Link>
      </Styled.Links>
    </Container>
  </Styled.Footer>
);

export default Footer;
